export default __webpack_public_path__ + "static/media/fpa40200.05a9ef43.png";